import { render, staticRenderFns } from "./AspacLoPresidentRegistrationCreate.vue?vue&type=template&id=7f4143bc&scoped=true"
import script from "./AspacLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
export * from "./AspacLoPresidentRegistrationCreate.vue?vue&type=script&lang=js"
import style0 from "./AspacLoPresidentRegistrationCreate.vue?vue&type=style&index=0&id=7f4143bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f4143bc",
  null
  
)

export default component.exports